import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, Heart, Crown, TrendingUp } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const SocialProofBanner = () => {
  const [stats, setStats] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/community/stats`);
        setStats(res.data);
      } catch (e) {
        // silencieux
      }
    };
    load();
  }, []);

  useEffect(() => {
    if (!stats) return;
    const t = setInterval(() => setCurrentIndex((i) => i + 1), 4000);
    return () => clearInterval(t);
  }, [stats]);

  if (!stats) return null;

  // 🌸 Élodie #783 — On ne montre PAS les items dont le nombre est 0
  //    (évite "0 mamans ont rejoint" qui donne mauvaise impression).
  // 🎯 Élodie #1001 — Retrait de "total_mamans dans la communauté" (jugé peu utile)
  //    + accord pluriel/singulier sur "match(es) créé(s)".
  const matchesText = stats.matches_this_month === 1
    ? `1 match créé ce mois-ci 💕`
    : `${stats.matches_this_month} matches créés ce mois-ci 💕`;
  const allItems = [
    {
      icon: <Users className="w-5 h-5" />,
      text: `+${stats.new_mamans_this_week} mamans ont rejoint MamaLink cette semaine`,
      gradient: 'from-[#A2D2FF] to-[#BDE0FE]',
      value: stats.new_mamans_this_week,
    },
    {
      icon: <Heart className="w-5 h-5" />,
      text: matchesText,
      gradient: 'from-[#FFB5A7] to-[#FCD5CE]',
      value: stats.matches_this_month,
    },
    {
      icon: <Crown className="w-5 h-5" />,
      text: `${stats.premium_this_month || stats.premium_today} mamans passées Premium 👑`,
      gradient: 'from-amber-300 to-yellow-400',
      value: stats.premium_this_month || stats.premium_today,
    },
  ];
  const items = allItems.filter(it => it.value && it.value > 0);
  if (items.length === 0) return null;
  const safeIndex = currentIndex % items.length;
  const current = items[safeIndex];

  return (
    <div
      className={`mb-4 rounded-2xl px-4 py-3 bg-gradient-to-r ${current.gradient} shadow-md text-white flex items-center gap-3 transition-all duration-500`}
      data-testid="social-proof-banner"
    >
      <div className="bg-white/20 rounded-full p-2 flex-shrink-0">
        {current.icon}
      </div>
      <p className="font-semibold text-sm flex-1">{current.text}</p>
      <div className="flex gap-1">
        {items.map((_, i) => (
          <div
            key={i}
            className={`w-1.5 h-1.5 rounded-full transition-all ${
              i === currentIndex ? 'bg-white w-4' : 'bg-white/40'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default SocialProofBanner;
